import { FreelancerInvoicesLazy } from "@js/apps/freelancer/views/lazy";
import { AppLayout } from "@js/layouts/app";

export const FreelancerInvoicesListingPage = () => (
  <AppLayout pageTitle="Invoices" flexColumn className="wider">
    <FreelancerInvoicesLazy />
  </AppLayout>
);
